export type RetreatInputType =
	| 'radio'
	| 'radioWithDescription'
	| 'checkbox'
	| 'dropdown'
	| 'text'
	| 'textarea'
	| 'months'

export interface RetreatOptionWithDescription {
	_key?: string
	title: string | Record<string, string>
	description?: string | Record<string, string>
}

export interface RetreatQuestion {
	title: string
	fieldKey: string
	inputType: RetreatInputType
	options?: Array<string>
	optionsWithDescription?: Array<RetreatOptionWithDescription> | Record<string, Array<RetreatOptionWithDescription>>
	placeholder?: string
	required?: boolean
	/** Resolved string after `localize()`, or locale-keyed object if data skipped normalization */
	description?: string | Record<string, string>
}

export function normalizeRetreatFieldKey (
	fieldKey: string | {current?: string} | undefined,
): string {
	if (!fieldKey) {
		return ''
	}
	if (typeof fieldKey === 'string') {
		return fieldKey
	}
	return fieldKey.current ?? ''
}
